/*
 * reports.js — esbuild IIFE entry
 * Migrated from app/assets/javascripts/reports.js
 * Provides Reports dashboard charts via Highcharts for all reports/* views.
 */
import Highcharts from 'highcharts';
import _Exporting from 'highcharts/modules/exporting';

// esbuild IIFE mode may wrap modules as { default: fn } — guard both cases.
function initHCModule(mod) {
    var fn = (mod && mod.default) ? mod.default : mod;
    if (typeof fn === 'function') { fn(Highcharts); }
}
initHCModule(_Exporting);
window.Highcharts = Highcharts;

window.Reports = {
    initializeDashboard(allData) {
        this._initializeTendersChart(allData.tenders, allData.params);
        this._initializeDocumentsChart(allData.document_sets, allData.params);
        this._initializeVerifiersPerformanceChart(allData.verifiers_performance, allData.params);
        setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
    },

    _nextDate(date, interval, to) {
        const to_date = new Date(to);
        let new_date;
        if (interval === 'daily') {
            new_date = new Date(date);
            new_date.setDate(new_date.getDate() + 1);
        } else if (interval === 'monthly') {
            new_date = new Date(date);
            new_date.setMonth(new_date.getMonth() + 1);
        } else {
            new_date = new Date(date);
            new_date.setFullYear(new_date.getFullYear() + 1);
        }
        return (new_date > to_date) ? to_date : new_date;
    },

    _stepValue(labels) {
        if (labels.length <= 12) { return 1; }
        if (labels.length <= 24) { return 2; }
        return Math.ceil(labels.length / 12);
    },

    _tooltipFormatter(that, data) {
        const date = this.x;
        const value = this.y;
        const name = this.series.name;
        return `<b>${date}</b><br/>${name}: <b>${value}</b>`;
    },

    _initializeTendersChart(data, params) {
        const that = this;
        $(() => {
            Highcharts.chart({
                chart: { renderTo: $('#tenders_container').exists()[0], type: 'column', height: 300, marginRight: 40 },
                credits: { enabled: false },
                title: { text: '' },
                xAxis: { categories: data.date_labels },
                yAxis: { min: 0, title: { text: I18n.t('my_reports.tenders.no_of_tenders') }, stackLabels: { enabled: true } },
                legend: { backgroundColor: '#FFFFFF', reversed: true },
                tooltip: { formatter() { return that._tooltipFormatter.apply(this, [that, data]); } },
                plotOptions: { series: { stacking: 'normal' } },
                colors: ['#928CDC', '#3F9505', '#FF7505', '#683C15', '#05478B', '#00A4E2', '#555250'],
                series: [
                    { name: 'unawarded', data: data.unawarded_count },
                    { name: 'awarded', data: data.awarded_count },
                    { name: 'opened', data: data.opened_count },
                    { name: 'on hold', data: data.on_hold_count },
                    { name: 'posted', data: data.posted_count },
                    { name: 'pending', data: data.pending_count },
                    { name: 'draft', data: data.draft_count }
                ]
            });
        });
    },

    _initializeDocumentsChart(data, params) {
        const that = this;
        $(() => {
            Highcharts.chart({
                chart: { renderTo: $('#documents_container').exists()[0], type: 'column', height: 300, marginRight: 40 },
                credits: { enabled: false },
                title: { text: '' },
                xAxis: { categories: data.date_labels },
                yAxis: { min: 0, title: { text: I18n.t('my_reports.document_sets.no_of_document_sets') }, stackLabels: { enabled: true } },
                legend: { backgroundColor: '#FFFFFF', reversed: true },
                tooltip: { formatter() { return that._tooltipFormatter.apply(this, [that, data]); } },
                plotOptions: { series: { stacking: 'normal' } },
                colors: ['#BB1F1A', '#3F9505', '#FF7505', '#05478B', '#555250'],
                series: [
                    { name: 'rejected', data: data.rejected_count },
                    { name: 'approved', data: data.approved_count },
                    { name: 'under review', data: data.under_review_count },
                    { name: 'submitted', data: data.submitted_count },
                    { name: 'draft', data: data.draft_count }
                ]
            });
        });
    },

    _initializeVerifiersPerformanceChart(data, params) {
        const that = this;
        $(() => {
            Highcharts.chart({
                chart: { renderTo: $('#verifiers_performance_container').exists()[0], type: 'line', height: 300, marginRight: 40 },
                credits: { enabled: false },
                title: { text: '' },
                xAxis: { categories: data.date_labels },
                yAxis: { min: 0, title: { text: I18n.t('my_reports.verifiers_performance.no_of_reviews') } },
                legend: { backgroundColor: '#FFFFFF', reversed: true },
                tooltip: { formatter() { return that._tooltipFormatter.apply(this, [that, data]); } },
                plotOptions: { series: { stacking: 'normal' } },
                series: [{ name: 'Reviews', data: data.data }]
            });
        });
    },

    initializeTenders(data) { this._initializeTendersChart(data, data.params); },
    initializeBids(data) {
        const that = this;
        $(() => {
            Highcharts.chart({
                chart: { renderTo: $('#bids_container').exists()[0], type: data.params.graph, height: 450, marginRight: 40 },
                credits: { enabled: false },
                title: { text: '' },
                xAxis: { categories: data.date_labels, labels: { step: that._stepValue(data.date_labels) } },
                yAxis: { min: 0, title: { text: data.params.scope === 'amount' ? 'Bidding Total in AED' : 'No. of Bids' }, stackLabels: { enabled: true } },
                legend: { backgroundColor: '#FFFFFF', reversed: true },
                tooltip: { formatter() { return that._tooltipFormatter.apply(this, [that, data]); } },
                plotOptions: { series: { stacking: 'normal' } },
                colors: ['#928CDC', '#3F9505', '#FF7505', '#683C15', '#05478B', '#00A4E2', '#555250'],
                series: [
                    { name: 'Awarded Bids', data: data.awarded_count },
                    { name: 'Submitted Bids', data: data.submitted_count }
                ]
            });
        });
    },
    initializeDocumentSets(data) {
        const that = this;
        $(() => {
            Highcharts.chart({
                chart: { renderTo: $('#document_sets_container').exists()[0], type: data.params.graph, height: 450, marginRight: 40 },
                credits: { enabled: false },
                title: { text: '' },
                xAxis: { categories: data.date_labels, labels: { step: that._stepValue(data.date_labels) } },
                yAxis: { min: 0, title: { text: I18n.t('my_reports.document_sets.no_of_document_sets') }, stackLabels: { enabled: true } },
                legend: { backgroundColor: '#FFFFFF', reversed: true },
                tooltip: { formatter() { return that._tooltipFormatter.apply(this, [that, data]); } },
                plotOptions: { series: { stacking: 'normal' } },
                colors: ['#BB1F1A', '#3F9505', '#FF7505', '#05478B', '#555250'],
                series: [
                    { name: 'rejected', data: data.rejected_count },
                    { name: 'approved', data: data.approved_count },
                    { name: 'under review', data: data.under_review_count },
                    { name: 'submitted', data: data.submitted_count },
                    { name: 'draft', data: data.draft_count }
                ]
            });
        });
    },
    initializeDocumentSetReviews(data) {
        const that = this;
        $(() => {
            Highcharts.chart({
                chart: { renderTo: $('#document_set_reviews_container').exists()[0], type: data.params.graph, height: 450, marginRight: 40 },
                credits: { enabled: false },
                title: { text: '' },
                xAxis: { categories: data.date_labels },
                yAxis: { min: 0, title: { text: I18n.t('my_reports.document_set_reviews.no_of_document_set_reviews') }, stackLabels: { enabled: true } },
                legend: { backgroundColor: '#FFFFFF', reversed: true },
                tooltip: { formatter() { return that._tooltipFormatter.apply(this, [that, data]); } },
                plotOptions: { series: { stacking: 'normal' } },
                series: data.series
            });
        });
    }
};
